import { render } from "./bundle-gallery-image-new.vue?vue&type=template&id=ad036ffc"
import script from "./bundle-gallery-image-new.vue?vue&type=script&lang=js"
export * from "./bundle-gallery-image-new.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-golive-uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__